export default "__VITE_ASSET__WVZFgssq__"